
import news from './jaNews';
export default {
    message: {
        bandName: '狂奏楽団',
        mailAddress: 'progressive-philosophy@kyousou-gakudan.com',
        copyRight: 'Copyright © 2007-{thisYear} 狂奏楽団. All Rights Reserved.',
        description: '狂奏楽団 - 2020年 再誕。 我々は生と死、信仰、在り方などを曲を通して問う。メタル、ヴィジュアル系、プログレッシブロック、Djent さぁ此の此土に遍く信仰と神の詩を奏で謳おう',
        // 各ページ用の情報
        information: {
            pageName: 'Information',
            buy: 'BUY NOW',
            whatsNews: news,
            event: {
                title: 'EVENTS',
                done: 'イベントお疲れ様でした。',
                events: {
                    e1:{
                        name: 'M3 2025 春',
                        date: '2025.04.27',
                        space: 'え-01b',
                        yyyymmdd: '20250427',
                        url:'https://www.m3net.jp/',
                    },
                    e2:{
                        name: 'コミックマーケット106',
                        date: '2025.08.16, 17',
                        space: '抽選待ち',
                        yyyymmdd: '20250817',
                        url:'https://www.comiket.co.jp/',
                    },
                },
            },
            snsWarning: "広告ブロックやサービスへのログイン状態などによっては表示出来ない場合があります。",
        },
        biography: {
            pageName: 'Biography',
            description: '狂奏楽団の来歴、メンバーを掲載。',
            band: {
                title: 'Band',
                explanation: `2007年、横浜で沙希哀を中心に結成。<br>
                我々は生と死、信仰、在り方などを曲を通して問う。<br>
                基本的に全ての曲は沙希哀が作詞作曲した彼の哲学であり、それらを総称しプログレッシブ哲学を成す。<br>
                メタル、ヴィジュアル系、プログレッシブロック、Djentなどの音楽に影響を受け、男女ヴォーカル、7弦ギター、5弦ベース、ドラムのスタンダードなバンド形式を基本に、ヴァイオリン、ピアノ、オルガンなどを多用する。<br>
                2007年から2012年までコミックマーケット、M3を中心にCDを頒布。<br>
                2012年、活動を休止。<br>
                2020年10月、再誕。<br>
                2021年12月31日、Chronicle Of Faithをコミックマーケット99にて発売。<br>
                2022年10月30日、DEMO CD FÜNF HEXEN (仮) #1をM3 2022 秋にて頒布。<br>
                2023年04月30日、DEMO CD FÜNF HEXEN (仮) #2をM3 2023 春にて頒布。<br>
                2025年04月27日、DEMO CD FÜNF HEXEN DEMO #3をM3 2025 春にて頒布。<br>
                2025年、五魔女 ～原初より鎖る衆愚の真諦は終に産生す因果たる化仏～を頒布予定<br>
                `,
            },
            members: {
                pageName: '楽団員',
                list: {
                    m01: {
                        name: '沙希哀',
                        role: ['作詞作曲', 'ギター', 'ベース', 'ヴォーカル...'],
                        twitter: '',
                        instagram: '',
                        bluesky: '',
                        threads: '',
                    },
                    m02: {
                        name: '卦ヰ',
                        role: ['ヴォーカル'],
                        twitter: '',
                        instagram: '',
                        bluesky: '',
                        threads: '',
                    },
                    m03: {
                        name: '翡翠',
                        role: ['ヴォーカル'],
                        twitter: '',
                        instagram: '',
                        bluesky: '',
                        threads: '',
                    },
                    m04: {
                        name: 'Cadaver',
                        role: ['ドラム'],
                        twitter: 'catdayversion',
                        instagram: '',
                        bluesky: '',
                        threads: '',
                    },
                    m05: {
                        name: 'M',
                        role: ['デザイン', 'ウェブデザイン...'],
                        twitter: 'm150mmmm',
                        instagram: 'm150_mmmm',
                        bluesky: 'm150mmmm.bsky.social',
                        threads: 'm150_mmmm',
                    }
                },
            },
        },
        discography: {
            pageName: 'Discography',
            description: '狂奏楽団のアルバム情報を掲載。',
            albums: {
                a10: {
                    id: 10,
                    name: 'Prologue',
                    description: 'Prologue 狂奏楽団 2010.08.14 発売',
                    date: '2010.08.14',
                    event: 'Comic market 78',
                    price: 100,
                    priceDl: 100,
                    priceShop: '',
                    advertisingSlogan: '神の所為で人が死ぬ 人は何に縋る<br>人が死にに往く 信仰の為に<br>神は喜んでいるか？',
                    tracks: {
                        t01: {
                            name: 'The World',
                            demo: '1_the_world',
                        },
                        t02: {
                            name: 'Vampire',
                            demo: '',
                        },
                        t03: {
                            name: '死する処女の涙',
                            demo: '',
                        },
                        t04: {
                            name: '子取',
                            demo: '4_kotori',
                        },
                        t05: {
                            name: 'The Empress',
                            demo: '5_the_empress',
                        },
                    },
                },
                a11: {
                    id: 11,
                    name: '罪鎖る衆愚の黒業は済度儚き輪転の咎',
                    description: '罪鎖る衆愚の黒業は済度儚き輪転の咎 狂奏楽団 2010.12.31 発売',
                    date: '2010.12.31',
                    event: 'Comic market 79',
                    price: 500,
                    priceDl: 500,
                    priceShop: '',
                    advertisingSlogan: '告発者は探し続ける罪を犯す咎人を 観自在に満眸の有涯を其の明眼で視る<br>貴方は唯罪を犯した 貴方は唯人を殺した',
                    tracks: {
                        t01: {
                            name: '罪の歪鎖',
                            demo: '',
                        },
                        t02: {
                            name: '惨澹と抉る告発者は冷酷な証人と',
                            demo: '2_santanto_eguru_kokuhatusyaha_reikokuna_akashibitoto',
                        },
                        t03: {
                            name: '愁歎の禍殃逓す断罪者',
                            demo: '3_syutanno_kaouteisu_danzaisya',
                        },
                        t04: {
                            name: '観測者塞くわだつみ抱え',
                            demo: '',
                        },
                        t05: {
                            name: '捩螺旋の咎',
                            demo: '',
                        },
                    },
                },
                a12: {
                    id: 12,
                    name: 'Alice Corpse',
                    description: 'Alice Corpse 狂奏楽団 2011.08.13 発売',
                    date: '2011.08.13',
                    event: 'Comic market 80',
                    price: 1000,
                    priceDl: 1000,
                    priceShop: '',
                    advertisingSlogan: '「今の暮らしは楽しいか？」<br>君を極彩の園に誘おう 其処は楽しく愉快で美しい楽園だ<br>失い気付く日々の平穏さ鼬の道と 深省し悔恨する涙濡ち暗澹たる心持で走る',
                    tracks: {
                        t01: {
                            name: '[All in the golden afternoon...]',
                            demo: '',
                        },
                        t02: {
                            name: 'AT REST',
                            demo: '02_at_rest',
                        },
                        t03: {
                            name: '狂謳',
                            demo: '',
                        },
                        t04: {
                            name: '極彩色の憧憬',
                            demo: '04_gokusaisikino_doukei',
                        },
                        t05: {
                            name: '[To wonderland...]',
                            demo: '',
                        },
                        t06: {
                            name: '日常から出る闇を抜けて至る光の楽園',
                            demo: '',
                        },
                        t07: {
                            name: '魔性の園',
                            demo: '07_masyono_sono',
                        },
                        t08: {
                            name: 'Mad Tea Party',
                            demo: '',
                        },
                        t09: {
                            name: '[The witch\'s game...]',
                            demo: '',
                        },
                        t10: {
                            name: '螺旋対談',
                            demo: '',
                        },
                        t11: {
                            name: 'blAcKJQ',
                            demo: '',
                        },
                        t12: {
                            name: 'The Balance Of Life.',
                            demo: '12_the_balance_of_life',
                        },
                        t13: {
                            name: '[They told me you had been to her...]',
                            demo: '',
                        },
                        t14: {
                            name: '黄金色の情景',
                            demo: '',
                        },
                        t15: {
                            name: '最後の願望',
                            demo: '',
                        },
                        t16: {
                            name: 'Alice Corpse',
                            demo: '',
                        },
                    },
                    remix: '2022 Remix AT REST',
                    remixDl: '2022 Remix AT REST 無料配布中',
                },
                a13: {
                    id: 13,
                    name: '「赤黒いお月さま、青白いお日さま」',
                    description: '「赤黒いお月さま、青白いお日さま」 狂奏楽団 2012.08.11 発売',
                    date: '2012.08.11',
                    event: 'Comic market 82',
                    price: 300,
                    priceDl: 300,
                    priceShop: '',
                    advertisingSlogan: '「殻に覆われあの日見た白に透ける青は綺麗だった」<br>「蹣跚めき攀じる階の先に開ける赤の血 ほろに別る骸亡き魂昇る黒の世」',
                    tracks: {
                        t01: {
                            name: '白雲の揺籃殻鏤め這い蹲う青天の下「孵化す肢」',
                            demo: '01_shirakumono_youran_karatiribamete_haitukubau_seitenno_moto_fukasu_ashi',
                        },
                        t02: {
                            name: '「青白いお日さま」',
                            demo: '',
                        },
                        t03: {
                            name: '赤地の箱庭骸鏤め飛び舞う黒天の下「羽化す翅」',
                            demo: '03_sekitino_hakoniwa_karatiribame_tobimau_kokutenno_moto_ukasu_hane',
                        },
                        t04: {
                            name: '「赤黒いお月さま」',
                            demo: '',
                        },
                    },
                },
                a14: {
                    id: 14,
                    name: 'Chronicle Of Faith',
                    description: 'Chronicle Of Faith 狂奏楽団 2021.12.31 発売',
                    date: '2021.12.31',
                    event: 'Comic market 99 金曜日 南ら-30b',
                    price: 1000,
                    priceDl: 1000,
                    priceShop: 1000,
                    advertisingSlogan: 'それでも神様はいるんだよね？',
                    tracks: {
                        t01: {
                            name: 'それでも神様はいるんだよね？',
                            demo: '01_soredemo_kamisamaha_irundayone',
                        },
                        t02: {
                            name: '赤色の供物',
                            demo: '',
                        },
                        t03: {
                            name: '悲恋詩',
                            demo: '03_hirenka',
                        },
                        t04: {
                            name: '天雷',
                            demo: '04_tenrai',
                        },
                        t05: {
                            name: '機械教',
                            demo: '',
                        },
                        t06: {
                            name: '首切神様',
                            demo: '',
                        },
                        t07: {
                            name: '終葬の戯曲',
                            demo: '',
                        },
                    },
                },
                a15: {
                    id: 15,
                    name: '五魔女 ～原初より鎖る衆愚の真諦は終に産生す因果たる化仏～',
                    description: '五魔女 ～原初より鎖る衆愚の真諦は終に産生す因果たる化仏～ 狂奏楽団 2024 頒布予定',
                    date: '2025 頒布予定',
                    event: '',
                    price: '',
                    priceDl: '',
                    priceShop: '',
                    advertisingSlogan: '産祝へ<br>「無窮の済度遣す魔法如く全能たる淑女」',
                    tracks: {
                        t01: {
                            name: '終に産生す因果たる化仏',
                            demo: '',
                        },
                        t02: {
                            name: '創生の魔女',
                            demo: '',
                        },
                        t03: {
                            name: '真実の魔女',
                            demo: '',
                        },
                        t04: {
                            name: '価値の魔女',
                            demo: '',
                        },
                        t05: {
                            name: '生命の魔女',
                            demo: '',
                        },
                        t06: {
                            name: '永遠の魔女',
                            demo: '',
                        },
                        t07: {
                            name: '原初より鎖る衆愚の真諦は',
                            demo: '',
                        },
                    },
                },
            },
            price: '価格: \xA5{price}',
            priceDl: 'DL価格: \xA5{price} (税別)',
            priceShop: '委託価格: \xA5{price} (税別)',
            priceToBeDetermined: '価格: 未定',
            dlSale: 'ダウンロード販売',
            sale: '委託販売',
            crossfade: 'クロスフェードデモ',
            specialThanks: 'Special Thanks',
            movie: 'Movie',
        },
        demo: {
            pageName: 'Demo CD',
            description: '狂奏楽団のDemo CDの情報を掲載。',
            free: 'BOOTHにて無料配布中',
            freeShort: '無料配布中',
            list: {
                demo1: {
                    id: 1,
                    name: 'FÜNF HEXEN (仮) #1',
                    date: '30 Okt 2022',
                    event: 'M3 2022 Herbst',
                    booth: 'https://kyousou-gakudan.booth.pm/items/4272625',
                    tracks: {
                        t1: 'Geschichte Hexe (仮) Demo',
                        t2: 'Goldnugget Hexe (仮) Demo',
                    },
                    youtube: ['y-Uso4tdjEc'],
                    youtubeShort: [],
                },
                demo2: {
                    id: 2,
                    name: 'FÜNF HEXEN (仮) #2',
                    date: '30 Apr 2023',
                    event: 'M3 2023 Frühling',
                    booth: 'https://kyousou-gakudan.booth.pm/items/4738776',
                    tracks: {
                        t1: 'Wahrheit Hexe (仮) Demo',
                        t2: 'Unsterbliche Hexe (仮) Demo',
                    },
                    youtube: ['5uA30OsKdEY'],
                    youtubeShort: [],
                },
                demo3: {
                    id: 3,
                    name: 'FÜNF HEXEN DEMO #3',
                    date: '27 Apr 2025',
                    event: 'M3 2025 Frühling',
                    booth: 'https://kyousou-gakudan.booth.pm/items/6853757',
                    tracks: {
                        t1: '真実の魔女 (Short ver)',
                        t2: '価値の魔女 (Short ver)',
                        t3: '創生の魔女 (Short ver)',
                    },
                    youtube: [],
                    youtubeShort: ['1P01VrLK4VE', '1CPeTWlhcm0', 'eTLE3KYnT90', '6lNMg9CFyys'],
                },
            }
        },
        distribution: {
            pageName: '配信',
            description: '配信リンク',
            streaming: 'ストリーミング配信',
            etc: 'その他',
            goToAlbum: 'アルバムページへ',
            cautionsToDlSale: 'DL販売について注意事項',
        },
        notFound: {
            pageName: '404 not found',
            description: '404 not found このページは存在しません。- 狂奏楽団',
            returnToHome: 'トップページへ戻る',
        },
        language: {
            ja: '日本語',
            en: 'English',
        },
        soundPlayer: {
            play: '再生',
            pause: '一時停止',
            stop: '停止',
            save: 'ダウンロード',
            volume: '音量',
            seek: 'シークバー',
        },
        shop: {
            // shop
            akibao: 'あきばおー',
            melonbooks: 'メロンブックス',
            amazon: 'Amazon',
            diskUnion: 'Disk Union',
            // dl
            bandcamp: 'Bandcamp',
            booth: 'BOOTH',
            dlSiteCom: 'DLsite',
            gyutto: 'Gyutto.com',
            melonbooksDl: 'メロンブックス DL',
            mucome: 'mucome',
            // streaming
            spotify: 'Spotify',
            appleMusic: 'Apple Music',
            lineMusic: 'LINE MUSIC',
            awa: 'AWA',
            kkBox: 'KKBOX',
            towerRecordsMusic: 'TOWER RECORDS MUSIC',
            amazonMusicUnlimited: 'Amazon Music Unlimited',
            utaPass: 'うたパス',
            dHits: 'dヒッツ',
            youtubeMusic: 'YouTube Music',
            rakutenMusic: '楽天 MUSIC',
            deezer: 'Deezer',
            anghami: 'Anghami',
            jioSaavn: 'JioSaavn',
            mixcloud: 'Mixcloud',
            pandora: 'Pandora',
            soundCloud: 'SoundCloud',
            unitedMediaAgency: 'United Media Agency',
            yandexMusic: 'Yandex Music',
            // dl(narasu)
            iTunesStore: 'iTunes Store',
            recochoku: 'レコチョク',
            amazonDigitalMusicStore: 'Amazonデジタルミュージックストア',
            dwangoJp: 'ドワンゴジェイピー',
            dMusic: 'd ミュージック',
            musicStore: 'Music Store',
            animeloMix: 'animelo mix',
            // etc
            facebookMusicStamp: 'Facebook ミュージックスタンプ',
            instagramMusicStamp: 'Instagram ミュージックスタンプ',
            gracenote: 'Gracenote',
            otoraku: '店舗BGMを作れるアプリ OTORAKU -音・楽-',
            popo: 'POPO',
            shazam: 'Shazam - 音楽発見、チャート & 歌詞', 
            tikTok: 'TikTok',          
        },
        snsName: {
            twitter: 'Twitter',
            instagram: 'Instagram',
            soundCloud: 'SoundCloud',
            youTube: 'YouTube',
            niconico: 'ニコニコ動画',
            line: 'LINE',
            faceBook: 'FaceBook',
            threads: 'Threads',
            bluesky: 'Bluesky',
            tikTok: 'TikTok',
            share: '{sns}でシェアする',
            copy: 'URLをコピーする',
            copySuccess: 'URLをコピーしました',
            copyError: 'URLコピーに失敗しました',
            openInstagram: 'この投稿をInstagramで見る',
            openTwitter: 'タイムラインをTwitterで見る',
        },
        common: {
            composition: '作曲',
            jacket: 'ジャケット',
            menu: 'メニュー',
            close: '閉じる',
        },
        aboutSite: {
            pageName: 'このサイトについて',
            description: 'このサイトについて。- 狂奏楽団',
            data: {
                aboutLyrics: '歌詞、詩、画像について',
                aboutLyricsDesc: `当バンドの歌詞および詩および画像の内容はフィクションです。<br>
                曲中、ジャケット、歌詞カード、サイトおよびその他の詩、画像で描写される出来事、国、土地、名前、人物、商品、法人、団体、シンボル、その他と、その名前は架空のものです。実在の出来事、国、土地、名前、人物、商品、法人、団体、シンボル、その他とのいかなる類似あるいは一致も、全くの偶然であり意図しないものです。`,
                aboutLink: 'リンクについて',
                aboutLinkDesc: `当サイトおよび公開しているコンテンツはリンクフリーです。ただし公序良俗に反したサイトからのリンクはお断り致します。<br>
                また、 当サイトから第三者のサイトにリンクを張っている場合や、第三者のサイトから当サイトにリンクを張っている場合、いずれの場合に於いても、第三者のサイトの内容は、第三者の責任で管理・運営されているものであり、それらを利用されたことによって生ずる如何なる不都合や損害についても、当バンドは責任を負いかねます。`,
                aboutDistribution: 'ストリーミング配信およびダウンロード販売について',
                aboutDistributionDesc: `ストリーミング配信及び一部ダウンロード販売は配信業者を介して各サイトに配信しているため当バンドで把握出来ていない配信先がある可能性がございます。<br>
                また、BOOTH、Bandcamp、各同人系ショップ以外のダウンロード販売業者のダウンロード販売価格は当バンドで決めた価格とずれがあるためサイトによって価格や付属する画像に違いがあることをご了承ください。`,
                banner: 'バナー',
                bannerUrl: 'https://kyousou-gakudan.com/banner/banner.png',
                contact: '連絡先',
                contactDesc: `メールアドレス: {mail}<br>
                {twitterSnsName}: <a class="link" href="{twitterUrl}" target="_blank" title="@{twitterId}">@{twitterId}</a>
                `,
            }
        },
    }
};